module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/icon_arrow-6468b8f69c12f17892716bdaab27445e.svg";